"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactDnd = require("react-dnd");

var _lodash = _interopRequireDefault(require("lodash.get"));

var _AssetPreview = _interopRequireDefault(require("../components/AssetPreview"));

var _utils = require("../../../../../../../../../common/utils");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var DRAG_TYPE = 'box';

function beginDrag(_ref) {
  var asset = _ref.asset;
  return {
    asset: asset
  };
}

function endDrag(draggedItem, monitor) {
  var dropResult = monitor.getDropResult();

  if (dropResult) {
    var onClipDrop = dropResult.onClipDrop,
        xPos = dropResult.xPos,
        yPos = dropResult.yPos;
    onClipDrop(draggedItem, {
      xPos: xPos,
      yPos: yPos
    });
  }
}

function hasDraggableType(_ref2) {
  var asset = _ref2.asset;
  var assetMetaData = (0, _lodash.default)(asset, 'metaData');

  if (!assetMetaData) {
    return false;
  }

  var parsedMetaData = JSON.parse(assetMetaData); // Allow only image and video mime type

  var matchersRegex = new RegExp('^[(video|image)]+/[-+\\w.]+$');
  return matchersRegex.test(parsedMetaData.type);
}

function getDragConfig(connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging()
  };
}

var dragHandlers = {
  beginDrag: beginDrag,
  endDrag: endDrag
};
var dragSource = (0, _reactDnd.DragSource)(DRAG_TYPE, dragHandlers, getDragConfig);

function AssetPreview(_ref3) {
  var canUpdateVideo = _ref3.canUpdateVideo,
      asset = _ref3.asset,
      props = _objectWithoutProperties(_ref3, ["canUpdateVideo", "asset"]);

  var canDrag = canUpdateVideo && hasDraggableType({
    asset: asset
  });
  var AssetPreviewWithDrag = (0, _utils.optionalDrag)(_AssetPreview.default, dragSource, canDrag);
  return (/*#__PURE__*/_react.default.createElement(AssetPreviewWithDrag, _extends({
      asset: asset,
      canDrag: canDrag
    }, props))
  );
}

var _default = (0, _react.memo)(AssetPreview);

exports.default = _default;